angular.module('unergie.main')
.directive('userInfoAccountBalance', () =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountBalance.html',
    })
)
